import axios, { AxiosHeaders } from 'axios'
import { useAppStore } from '@/stores/AppStore'

const http = axios.create()

/**
 * Resolve the current UI language for request headers.
 *
 * Rules:
 * - Every request will be forced to use the app's current language via `Accept-Language`.
 * - Per-request overrides are NOT supported (any provided `Accept-Language` will be overwritten).
 *
 * ทุก request ที่เรียกผ่าน http จะต้องมี `Accept-Language` ตามภาษาปัจจุบันของผู้ใช้
 */
function resolveRequestLanguage(): string {
  try {
    const appStore = useAppStore()
    if (appStore.language) return appStore.language
  } catch {}

  // const lsLang = storage.getItem('language')
  // if (lsLang) return String(lsLang)

  // if (i18next.language) return i18next.language

  return 'th'
}

http.interceptors.request.use(config => {
  // Normalize headers for type-safety and consistent casing behavior.
  const headers = AxiosHeaders.from(config.headers)

  // Always sync header at request-time to avoid off-by-one bugs when app language changes.
  headers.set('Accept-Language', resolveRequestLanguage())

  config.headers = headers

  return config
})

export default http
